"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NettestGroupMiddleBoxes = function NettestGroupMiddleBoxes(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 30 30"
  }, props), _react.default.createElement("g", null, _react.default.createElement("defs", null), _react.default.createElement("title", null, "Middle Boxes"), _react.default.createElement("g", null, _react.default.createElement("polygon", {
    points: "22.232 6.653 10.382 12.578 10.382 17.022 7.419 15.541 7.419 11.097 19.269 5.172 14.826 2.95 2.976 8.875 2.976 20.725 14.826 26.65 26.676 20.725 26.676 8.875 22.232 6.653"
  }))));
};

var _default = NettestGroupMiddleBoxes;
exports.default = _default;